/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getNurses } from 'app/entities/nurse/nurse.reducer';
import { Specimen } from 'app/shared/model/enumerations/specimen.model';
import { PatientCondition } from 'app/shared/model/enumerations/patient-condition.model';
import { createEntity, getEntity, reset, updateEntity } from './intra-op-nursing-record.reducer';

export const IntraOPNursingRecordUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const nurses = useAppSelector(state => state.nurse.entities);
  const intraOPNursingRecordEntity = useAppSelector(state => state.intraOPNursingRecord.entity);
  const loading = useAppSelector(state => state.intraOPNursingRecord.loading);
  const updating = useAppSelector(state => state.intraOPNursingRecord.updating);
  const updateSuccess = useAppSelector(state => state.intraOPNursingRecord.updateSuccess);
  const specimenValues = Object.keys(Specimen);
  const patientConditionValues = Object.keys(PatientCondition);

  const handleClose = () => {
    navigate(`/intra-op-nursing-record${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getNurses({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.procedureStart !== undefined && typeof values.procedureStart !== 'number') {
      values.procedureStart = Number(values.procedureStart);
    }
    if (values.procedureEnd !== undefined && typeof values.procedureEnd !== 'number') {
      values.procedureEnd = Number(values.procedureEnd);
    }
    if (values.timeSent !== undefined && typeof values.timeSent !== 'number') {
      values.timeSent = Number(values.timeSent);
    }
    if (values.timeOfReport !== undefined && typeof values.timeOfReport !== 'number') {
      values.timeOfReport = Number(values.timeOfReport);
    }
    if (values.timeInformed !== undefined && typeof values.timeInformed !== 'number') {
      values.timeInformed = Number(values.timeInformed);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...intraOPNursingRecordEntity,
      ...values,
      surgery: patientProcedures.find(it => it.id.toString() === values.surgery?.toString()),
      scrubNurse: nurses.find(it => it.id.toString() === values.scrubNurse?.toString()),
      circulatingNurse: nurses.find(it => it.id.toString() === values.circulatingNurse?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          specimen: 'PATHOLOGY',
          conditionAtEnd: 'STABLE',
          ...intraOPNursingRecordEntity,
          surgery: intraOPNursingRecordEntity?.surgery?.id,
          scrubNurse: intraOPNursingRecordEntity?.scrubNurse?.id,
          circulatingNurse: intraOPNursingRecordEntity?.circulatingNurse?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.intraOPNursingRecord.home.createOrEditLabel" data-cy="IntraOPNursingRecordCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.home.createOrEditLabel">
              Create or edit a IntraOPNursingRecord
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="intra-op-nursing-record-id"
                  label={translate('tinyMedicRestApp.intraOPNursingRecord.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.procedureStart')}
                id="intra-op-nursing-record-procedureStart"
                name="procedureStart"
                data-cy="procedureStart"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.procedureEnd')}
                id="intra-op-nursing-record-procedureEnd"
                name="procedureEnd"
                data-cy="procedureEnd"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.specimen')}
                id="intra-op-nursing-record-specimen"
                name="specimen"
                data-cy="specimen"
                type="select"
              >
                {specimenValues.map(specimen => (
                  <option value={specimen} key={specimen}>
                    {translate(`tinyMedicRestApp.Specimen.${specimen}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.timeSent')}
                id="intra-op-nursing-record-timeSent"
                name="timeSent"
                data-cy="timeSent"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.timeOfReport')}
                id="intra-op-nursing-record-timeOfReport"
                name="timeOfReport"
                data-cy="timeOfReport"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.countsCorrect')}
                id="intra-op-nursing-record-countsCorrect"
                name="countsCorrect"
                data-cy="countsCorrect"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.surgeonInformed')}
                id="intra-op-nursing-record-surgeonInformed"
                name="surgeonInformed"
                data-cy="surgeonInformed"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.timeInformed')}
                id="intra-op-nursing-record-timeInformed"
                name="timeInformed"
                data-cy="timeInformed"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.actionRemarks')}
                id="intra-op-nursing-record-actionRemarks"
                name="actionRemarks"
                data-cy="actionRemarks"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.actionTaken')}
                id="intra-op-nursing-record-actionTaken"
                name="actionTaken"
                data-cy="actionTaken"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.conditionAtEnd')}
                id="intra-op-nursing-record-conditionAtEnd"
                name="conditionAtEnd"
                data-cy="conditionAtEnd"
                type="select"
              >
                {patientConditionValues.map(patientCondition => (
                  <option value={patientCondition} key={patientCondition}>
                    {translate(`tinyMedicRestApp.PatientCondition.${patientCondition}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.equipmentProblem')}
                id="intra-op-nursing-record-equipmentProblem"
                name="equipmentProblem"
                data-cy="equipmentProblem"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.equipmentProblemNotes')}
                id="intra-op-nursing-record-equipmentProblemNotes"
                name="equipmentProblemNotes"
                data-cy="equipmentProblemNotes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.actionNotes')}
                id="intra-op-nursing-record-actionNotes"
                name="actionNotes"
                data-cy="actionNotes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.implant')}
                id="intra-op-nursing-record-implant"
                name="implant"
                data-cy="implant"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.active')}
                id="intra-op-nursing-record-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.cursor')}
                id="intra-op-nursing-record-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.lastupdated')}
                id="intra-op-nursing-record-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.microSec')}
                id="intra-op-nursing-record-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPNursingRecord.timestampentry')}
                id="intra-op-nursing-record-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="intra-op-nursing-record-surgery"
                name="surgery"
                data-cy="surgery"
                label={translate('tinyMedicRestApp.intraOPNursingRecord.surgery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="intra-op-nursing-record-scrubNurse"
                name="scrubNurse"
                data-cy="scrubNurse"
                label={translate('tinyMedicRestApp.intraOPNursingRecord.scrubNurse')}
                type="select"
                required
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="intra-op-nursing-record-circulatingNurse"
                name="circulatingNurse"
                data-cy="circulatingNurse"
                label={translate('tinyMedicRestApp.intraOPNursingRecord.circulatingNurse')}
                type="select"
                required
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/intra-op-nursing-record" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default IntraOPNursingRecordUpdate;
